import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getVarietiesWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_VARIETY_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};